import Image from 'next/image'
import React from 'react'
import { MdOutlineTimer } from 'react-icons/md'

import Card from './card'

import { rewardFormat } from '@/libs/helpers/get-reward-currency'
import useUpToRewardLabel from '@/libs/logics/use-up-to-reward-label'
import { ERewardType, SURVEY_CATEGORY, SURVEY_PROVIDER } from '@/libs/types/global.types'

export type TSurveyCard = {
  title: string
  time: number
  rewardType: ERewardType
  reward: number
  surveyType: SURVEY_CATEGORY
  surveyProvider: SURVEY_PROVIDER
  readonly useOwnLoyaltyPlatform?: boolean
  readonly loyaltyPlatform?: {
    loyaltyPlatformIcon: string
    loyaltyPlatformName: string
    loyaltyPlatformPrefix?: string
    loyaltyPlatformSuffix?: string
  }
}

export default function SurveyCard(data: Readonly<TSurveyCard>) {
  const isUpToRewardLabel = useUpToRewardLabel({
    surveyType: data?.surveyType,
    surveyProvider: data?.surveyProvider,
  })

  const rewardPrefix = isUpToRewardLabel ? 'Up to ' : ''
  const { image, prefix, suffix, reward } = rewardFormat({
    useOwnLoyaltyPlatform: data?.useOwnLoyaltyPlatform,
    loyaltyPlatform: data?.loyaltyPlatform,
    rewardType: data.rewardType,
    rewardAmount: data.reward,
    rewardPrefix,
  })

  return (
    <Card>
      <div className='sentry-mask flex flex-col gap-5'>
        <div className='flex flex-row justify-between'>
          <span className='text-sm font-medium'>{data?.title}</span>
          <div className='flex flex-row items-center gap-1'>
            <MdOutlineTimer className='h-4 w-4 text-pop-grey-800' />
            <span className='text-xs'>
              {data?.time} Min{data?.time > 1 && 's'}
            </span>
          </div>
        </div>
        <div className='flex flex-row items-end justify-between'>
          <div className='bottom-1 flex flex-row items-center gap-2 rounded-full border border-pop-gray-5 px-2 py-1'>
            {image?.alt && image?.src && (
              <Image src={image?.src ?? ''} alt={image?.alt} width={18} height={18} />
            )}

            <span className='sentry-mask text-xs font-semibold text-pop-business-blue'>
              {prefix}
              {reward} {suffix}
            </span>
          </div>
        </div>
      </div>
    </Card>
  )
}
